export default "__VITE_ASSET__Dvh73btb__"